<template>
  <td valign="top" class="default-ad" v-on:click.prevent="trackAdLink(ad)">
    <table>
      <tbody>
        <tr>
          <td class="ad-info">
            <div v-if="ad.adCopy">
              <b>{{ad.account.name}}</b><br/>
              <span v-html="ad.adCopy"></span>
            </div>
            <div v-else>
              <b>{{ad.account.name}}</b>
            </div>
          </td>
          <td class="apy-info">
            <div class="apy-text">{{$filters.percentageFilter(ad.account.apy)}} <apy-label></apy-label></div>
            <img v-bind:src="bankImage" v-bind:alt="ad.account.bankName">
          </td>
        </tr>
      </tbody>
    </table>
    <IMG class="ad-pixel" v-bind:src="$filters.formatTrackingFilter(ad.pixel)" width="1" height="1" alt/>
  </td>
</template>

<script lang="ts">
import Vue, { defineComponent } from "vue";
import "../../../utils/filters";
import { adClickMixin } from "../../../mixins/adClickMixin";
import apyLabel from "../../../components/apyLabel.vue";

export default defineComponent({
  components: {
    apyLabel: apyLabel
  },
  mixins: [adClickMixin],
  props: {
    ad: Object
  },
  computed: {
    bankImage(): string {
      return `${process.env.VUE_APP_CONTENT_URI}/spnsr/${this.ad.account.bankUrl}/100x50.png`;
    }
  }
});
</script>
<style lang="scss" scoped>
.default-ad {
  width: 50%;
  background-color: inherit;
  padding: 5px 5px 0px 5px;
  &:first-child {
    border-right: 1px solid #999;
  }
  &:not(:first-child) {
    padding-left: 20px;
  }
  table {
    width: 100%;
    line-height: 18px;
  }
  .ad-info {
    max-width: 190px;
    vertical-align: top;

    //https://vue-loader.vuejs.org/guide/scoped-css.html#deep-selectors
    :host ::ng-deep b {
      text-decoration: underline;
      color: #4699bb;
      margin-bottom: 4px;
      font-size: 12px;
    }
  }
  .apy-info {
    vertical-align: top;

    .apy-text {
      text-decoration: underline;
      color: #4699bb;
    }
  }
  .ad-pixel {
    display: none;
  }
}
</style>
